<template>

    <div class="modal-container" :class="{show:showModal}">
        <div class="overlay" @click="hide"></div>
        <div class="modal danger" :style="forcedSize">
            <h3>
                <span v-html="Ioptions.title"></span>
                <font-awesome-icon icon="times" @click="hide"/>
            </h3>
            <div class="modal-content-container" id="modalContent" v-html="Ioptions.content">

            </div>
            <div>
                <Btn class="primary danger pull-right" :class="{disabled:Ioptions.doubleConfirm && !doubleConfirmAccept}" @click.native.stop="accept">
                    {{ $t('global.yes') }}
                </Btn>
                <Btn class="default pull-right" @click.native.stop="decline">
                    {{ $t('global.no') }}
                </Btn>
            </div>
        </div>
    </div>






</template>

<script>
    import Btn from '@/components/ui/Button';

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            Btn
        },
        computed: {
            forcedSize: function(){
                var style = '';
                if(this.width){
                    style = style + 'width:' + this.width + ';';
                }
                if(this.height){
                    style = style + 'height:' + this.height + ';';
                }

                return style;
            }
        },
        created: function () {

        },
        data () {
            return {
                Ioptions: {},
                showModal: false,
                doubleConfirmAccept: false,
            }
        },
        destroyed: function () {

        },
        methods: {
            show: function(options){
                this.Ioptions = options;
                this.doubleConfirmAccept = false;
                //window.Vfc.blurMode(true);
                this.showModal = true;
            },
            hide: function(){
                //window.Vfc.blurMode(false);
                this.showModal = false;
            },
            accept: function(){
                if(this.Ioptions.callbackYes){
                    this.Ioptions.callbackYes();
                }
                this.hide();
            },
            decline: function(){
                if(this.Ioptions.callbackNo){
                    this.Ioptions.callbackNo();
                }
                this.hide();
            }
        },
        mounted: function () {

        },
        name: '',
        props: {
            width:[Number],
            height:[Number],
            options: {
                type: [Object],
                default: function(){
                    return {
                        doubleConfirm: false,
                        doubleConfirmMessage: '',
                        title: '',
                        content: '',
                        callbackYes: null,
                        callbackNo: null
                    }
                }
            }
        },
        updated: function () {

        },
        watch: {
            options: function(newValue){
                this.Ioptions = newValue;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ui/Confirm.vue